// Environment configuration

// Define the API base URL based on the current environment
const isDevelopment = import.meta.env.DEV;

export const config = {
  // API base URL - using environment variable or fallback
  apiBaseUrl: import.meta.env.VITE_API_URL || (isDevelopment 
    ? '' // Empty string for development (will use Vite's proxy)
    : 'https://api.cvo2.symplex.fr'), // Production URL fallback
  
  // Other configuration values can be added here
  appName: 'Paragliding Flight Logbook',
  version: '1.0.0'
};